/* bt-lead-popup.js — свій поп-ап заявки з мітками відстеження (24.10.2026).
 *
 * ОДНАКОВИЙ файл у двох темах (UA Bricktopia / PL Kloniko). Розмітку, тексти
 * мовою сторінки й налаштування сторінки кладе секція sections/bt-lead-popup.liquid
 * («Bt: Lead popup») — JSON у <script type="application/json" data-bt-leadpop-cfg>.
 *
 * Хто відкриває поп-ап:
 *   • будь-який елемент з атрибутом data-lead-popup (значення — ключ кнопки для звітів);
 *   • якщо в секції увімкнено «перехоплення» — старі кнопки попапа «Напишіть нам»
 *     (.button-message / [data-popup-trigger]), посилання на сторінку контактів у тілі
 *     сторінки і (корп-сторінки) посилання на #bryf. Шапка, підвал, меню й плаваюча
 *     кнопка зв'язку НЕ перехоплюються.
 *
 * Мітки (від загального до конкретного, кожен рівень перекриває попередній):
 *   налаштування секції → рядок «Правила для кнопок» → data-атрибути кнопки:
 *     data-lead-kind      contact_popup | corp_brief | callback
 *     data-lead-title / data-lead-text / data-lead-comment   — заголовок, підзаголовок, підказка коментаря
 *     data-lead-meta      Lead | Contact | SubmitApplication | Schedule | <своя подія> | off
 *     data-lead-meta-category / data-lead-meta-name          — content_category / content_name
 *     data-lead-gads      мітка конверсії Google Ads (або AW-…/мітка) | off
 *     data-lead-ga4       назва події GA4 (типово generate_lead) | off
 *     data-lead-value     цінність заявки для Meta / Google Ads (у валюті магазину)
 *     data-lead-tags      "utm_campaign=bf;utm_content=hero" — у заявку і в параметри подій
 *
 * Поля: зручний спосіб (чипи), телефон і ЩЕ ОДИН контакт (пошта / нік) — завжди два, бо один може
 * виявитися неробочим (власник 24.10.2026). Імʼя, коментар.
 *
 * Заявка йде тим самим конвеєром, що й бриф (st11, sklad SITE-LEADS-GUIDE.md):
 * window.btLead.send → склад (вкладка «Заявки з сайту»); склад не відповів —
 * bt-lead.js сам шле повний текст у kickflip; bt-lead.js не завантажився — kickflip
 * напряму. Події — РІВНО ОДИН раз і лише після доставки (не для пастки на ботів).
 *
 * Meta: eventID 'lead_' + client_id. Для corp_brief (і callback на B2B-сторінці)
 * подія завжди Lead з content_category = b2b — склад шле серверний дубль з тим самим
 * event_id (lib/site-leads-meta.ts), Meta склеює; своя конверсія «B2B заявка» її бачить.
 * UA: fbq ставить канал Facebook & Instagram на сторінці. PL: fbq на вітрині НЕМАЄ —
 * вантажимо fbevents самі, лише за згоди на маркетинг (Consentmo → customerPrivacy),
 * без PageView, autoConfig=false; прапорець ініціалізації спільний з bt-socd-designer.js.
 * Google Ads / GA4: gtag (на UA його ставить застосунок Google, на PL — вантажимо самі
 * за згоди), transaction_id = 'lead_' + client_id.
 *
 * ES5, без ?. і ?? (Safari 14). Публічне: window.btLeadPopup.open(el|null, overrides).
 */
(function () {
  'use strict';
  if (window.btLeadPopup) return;

  var CONTACT_RE = /\/pages\/(contact|kontakt|kontakty)(?=$|[?#\/])/;
  var CHROME_SEL = 'header, footer, nav, .menu-drawer, #popupOverlay, .bt-cb, [data-bt-leadpop], ' +
    '.shopify-section-group-header-group, .shopify-section-group-footer-group';
  /* Старі кнопки попапа «Напишіть нам» перехоплюються й у меню (пункт у мобільному меню). */
  var OLD_SKIP_SEL = '#popupOverlay, .bt-cb, [data-bt-leadpop]';
  var KINDS = { contact_popup: 1, corp_brief: 1, callback: 1 };
  var META_STD = { Lead: 1, Contact: 1, SubmitApplication: 1, Schedule: 1, CompleteRegistration: 1 };
  var NOTIFY_URL = 'https://web-production-05000.up.railway.app/site/notify';

  var root = null, cfg = null, els = {}, cur = null, lastFocus = null, busy = false, opened = 0;

  /* ── дрібниці ─────────────────────────────────────────────────────────── */

  function str(v, max) {
    var s = v === undefined || v === null ? '' : String(v);
    s = s.replace(/^\s+|\s+$/g, '');
    return max && s.length > max ? s.slice(0, max) : s;
  }
  function own(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function extend(a, b) { for (var k in b) if (own(b, k) && b[k] !== undefined && b[k] !== '') a[k] = b[k]; return a; }
  function fmt(s, vars) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && own(vars, k) ? vars[k] : ''; });
  }

  var TR = {
    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd', 'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y',
    'і': 'i', 'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's',
    'т': 't', 'у': 'u', 'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ь': '', 'ю': 'iu',
    'я': 'ia', 'ы': 'y', 'э': 'e', 'ё': 'e', 'ъ': '', 'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o',
    'ś': 's', 'ź': 'z', 'ż': 'z', 'ä': 'a', 'ö': 'o', 'ü': 'u', 'ß': 'ss', 'à': 'a', 'è': 'e', 'é': 'e', 'ì': 'i',
    'ò': 'o', 'ù': 'u'
  };
  /* Ключ кнопки для звітів латиницею: «Надіслати файл .io →» → nadislaty-fail-io */
  function slug(s, max) {
    var t = String(s || '').toLowerCase(), out = '';
    for (var i = 0; i < t.length; i++) {
      var c = t.charAt(i);
      out += own(TR, c) ? TR[c] : c;
    }
    out = out.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return out.slice(0, max || 40).replace(/-+$/, '');
  }

  function privacy() {
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; return cp || null; } catch (e) { return null; }
  }
  /* UA — банера згоди немає: заборонено лише явне false (як btTrack).
     PL — Consentmo: потрібне явне true. */
  function marketingOk() {
    var cp = privacy();
    try {
      if (cp && typeof cp.marketingAllowed === 'function') {
        var v = cp.marketingAllowed();
        return cfg.store === 'PL' ? v === true : v !== false;
      }
    } catch (e) {}
    return cfg.store !== 'PL';
  }
  function analyticsOk() {
    var cp = privacy();
    try {
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        var v = cp.analyticsProcessingAllowed();
        return cfg.store === 'PL' ? v === true : v !== false;
      }
    } catch (e) {}
    return cfg.store !== 'PL';
  }

  function attribution() {
    try {
      if (window.btAttribution && typeof window.btAttribution.get === 'function') return window.btAttribution.get() || {};
      var a = JSON.parse(localStorage.getItem('bt_attr_v1') || 'null');
      return a && typeof a === 'object' ? a : {};
    } catch (e) { return {}; }
  }

  function cookie(n) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function uuid() {
    try { if (window.btLead && typeof window.btLead.uuid === 'function') return window.btLead.uuid(); } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 3 | 8)).toString(16);
    });
  }

  /* «utm_campaign=bf;utm_content=hero» → {utm_campaign:'bf', utm_content:'hero'} */
  function parseTags(s) {
    var out = {};
    String(s || '').split(/[;&\n]/).forEach(function (part) {
      var i = part.indexOf('=');
      if (i < 1) return;
      var k = str(part.slice(0, i)).toLowerCase().replace(/[^a-z0-9_]/g, '').slice(0, 40);
      var v = str(part.slice(i + 1), 100);
      if (k && v) out[k] = v;
    });
    return out;
  }
  function tagsString(o) {
    var a = [];
    for (var k in o) if (own(o, k)) a.push(k + '=' + o[k]);
    return a.join('; ').slice(0, 300);
  }

  /* ── налаштування кнопки ──────────────────────────────────────────────── */

  /* «Правила для кнопок» із секції: «ключ або його початок => meta:Contact; gads:AbC…» */
  function parseRules(text) {
    var out = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      line = str(line);
      if (!line || line.charAt(0) === '#') return;
      var i = line.indexOf('=>');
      if (i < 1) return;
      var pat = str(line.slice(0, i)).toLowerCase();
      var set = {};
      line.slice(i + 2).split(';').forEach(function (kv) {
        var j = kv.indexOf(':');
        if (j < 1) return;
        var k = str(kv.slice(0, j)).toLowerCase().replace(/-/g, '_');
        var v = str(kv.slice(j + 1), 300);
        if (k) set[k] = v;
      });
      if (pat) out.push({ pat: pat, set: set });
    });
    return out;
  }

  function sectionKey(el) {
    var sec = el && el.closest ? el.closest('.shopify-section') : null;
    if (!sec || !sec.id) return 'page';
    return sec.id.replace(/^shopify-section-(template--\d+__|sections--\d+__)?/, '').toLowerCase().slice(0, 40) || 'page';
  }

  function buttonText(el) {
    if (!el) return '';
    var t = el.getAttribute('aria-label') && !str(el.textContent) ? el.getAttribute('aria-label') : el.textContent;
    return str(String(t || '').replace(/\s+/g, ' ').replace(/[→›»]+/g, ''), 80);
  }

  function buttonKey(el) {
    if (!el) return 'manual';
    var v = el.getAttribute('data-lead-popup');
    if (v) return slug(v, 60) || 'button';
    var t = buttonText(el);
    return (sectionKey(el) + (t ? ':' + slug(t, 32) : '')).slice(0, 60);
  }

  function attrSet(el) {
    var s = {};
    if (!el || !el.getAttribute) return s;
    var map = {
      kind: 'data-lead-kind', title: 'data-lead-title', text: 'data-lead-text', comment: 'data-lead-comment',
      meta: 'data-lead-meta', meta_category: 'data-lead-meta-category', meta_name: 'data-lead-meta-name',
      gads: 'data-lead-gads', ga4: 'data-lead-ga4', value: 'data-lead-value', tags: 'data-lead-tags'
    };
    for (var k in map) if (own(map, k)) {
      var v = el.getAttribute(map[k]);
      if (v !== null && v !== '') s[k] = v;
    }
    return s;
  }

  /* Підсумкові налаштування для цієї кнопки. */
  function resolve(el, via, overrides) {
    var d = cfg.defaults || {};
    var o = {
      kind: d.kind, title: d.title || '', text: d.text || '', comment: d.comment || '',
      meta: d.meta, meta_category: d.meta_category, meta_name: d.meta_name,
      gads: d.gads, ga4: d.ga4, value: d.value, tags: d.tags
    };
    var key = overrides && overrides.key ? slug(overrides.key, 60) : buttonKey(el);
    var rules = cfg._rules || [];
    for (var i = 0; i < rules.length; i++) {
      var p = rules[i].pat;
      if (p === '*' || key === p || key.indexOf(p) === 0) extend(o, rules[i].set);
    }
    extend(o, attrSet(el));
    if (overrides) extend(o, overrides);

    o.kind = KINDS[o.kind] ? o.kind : 'contact_popup';
    o.b2b = o.kind === 'corp_brief' || (o.kind === 'callback' && !!cfg.b2b);
    if (o.b2b) {
      /* Своя конверсія «B2B заявка» = Lead + content_category b2b; склад шле
         серверний Lead з тим самим event_id — назва події мусить збігатися. */
      o.meta = 'Lead';
      o.meta_category = 'b2b';
      o.meta_name = o.kind === 'corp_brief' ? 'b2b_raschet' : 'b2b_callback';
      o.meta_lead = o.meta_name;
    }
    o.key = key;
    o.via = via || 'api';
    o.btnText = buttonText(el);
    o.page = cfg.page || 'page';
    o.tagsObj = parseTags(o.tags);
    var val = parseFloat(String(o.value || '').replace(',', '.'));
    o.valueNum = val > 0 ? Math.round(val * 100) / 100 : 0;
    return o;
  }

  /* ── відкриття / закриття ─────────────────────────────────────────────── */

  function inChrome(el) { return !!(el.closest && el.closest(CHROME_SEL)); }

  function triggerFor(target) {
    var el = target.closest('[data-lead-popup]');
    if (el && !el.closest('[data-bt-leadpop]')) return [el, 'attr'];
    var tk = cfg.takeover || {};
    if (tk.old) {
      el = target.closest('.button-message, [data-popup-trigger]');
      if (el && !el.closest(OLD_SKIP_SEL)) return [el, 'old-popup'];
    }
    var a = target.closest('a[href]');
    if (a && !inChrome(a)) {
      var href = a.getAttribute('href') || '';
      /* На самій сторінці контактів її посилання лишаються посиланнями. */
      if (tk.contact && CONTACT_RE.test(href) && !CONTACT_RE.test(location.pathname)) return [a, 'contact-link'];
      if (tk.bryf && /#bryf$/.test(href)) return [a, 'bryf'];
    }
    return null;
  }

  function onClick(e) {
    if (!cfg || e.defaultPrevented) return;
    if (e.button !== undefined && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = triggerFor(t);
    if (!hit) return;
    e.preventDefault();
    /* Старий попап «Напишіть нам» слухає той самий клік на document — не пускаємо. */
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open(hit[0], hit[1]);
  }

  function setText(el, v) { if (el) el.textContent = v || ''; }

  function open(el, via, overrides) {
    if (!root) return;
    cur = resolve(el, via, overrides);
    var t = cfg.t || {};
    setText(els.title, cur.title || (cur.b2b ? t.title_b2b : t.title));
    setText(els.sub, cur.text || (cur.b2b ? t.sub_b2b : t.sub));
    if (els.comment) els.comment.setAttribute('placeholder', cur.comment || (cur.b2b ? t.comment_ph_b2b : t.comment_ph) || '');
    showForm();
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bt-leadpop-lock');
    /* Наступний кадр — щоб спрацював CSS-перехід. */
    setTimeout(function () { root.classList.add('is-open'); }, 10);
    setTimeout(function () {
      var f = root.querySelector('input[name="phone"]');
      try { if (f && window.matchMedia && !window.matchMedia('(pointer: coarse)').matches) f.focus(); else if (els.dialog) els.dialog.focus(); } catch (e) {}
    }, 60);
    opened++;
    trackOpen(cur);
  }

  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bt-leadpop-lock');
    setTimeout(function () { root.hidden = true; }, 200);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
  }

  function showForm() {
    if (els.fields) els.fields.hidden = false;
    if (els.ok) els.ok.hidden = true;
    if (els.err) { els.err.hidden = true; els.err.textContent = ''; }
    if (els.alt) els.alt.hidden = true;
  }

  /* ── форма ────────────────────────────────────────────────────────────── */

  function method() {
    var r = root.querySelector('input[name="bt_lp_method"]:checked');
    return r ? { label: r.value, ch: r.getAttribute('data-ch') || 'custom', kind: r.getAttribute('data-kind') || 'text', hint: r.getAttribute('data-hint') || '' } : null;
  }

  /* Телефон питаємо завжди; друге поле — «ще один контакт» (пошта або нік), а якщо
     зручніше поштою — саме пошта. Власник 24.10.2026: завжди два способи звʼязку,
     бо один може виявитися неробочим. */
  function syncMethod() {
    var m = method();
    var c = els.contact;
    var t = cfg.t || {};
    if (!m || !c) return;
    var mail = m.kind === 'mail';
    if (els.contactLabel) els.contactLabel.textContent = mail ? (m.hint || t.second) : (t.second || '');
    if (els.contactHint) { els.contactHint.textContent = mail ? '' : (t.second_hint || ''); els.contactHint.hidden = mail; }
    c.type = mail ? 'email' : 'text';
    c.autocomplete = 'email';
    c.setAttribute('placeholder', mail ? 'name@gmail.com' : (t.second_ph || ''));
  }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function fail(msg, withAlt) {
    if (els.err) { els.err.textContent = msg; els.err.hidden = false; }
    if (els.alt) els.alt.hidden = !withAlt;
  }

  function setBusy(on) {
    busy = on;
    if (!els.submit) return;
    els.submit.disabled = on;
    els.submit.textContent = on ? (cfg.t || {}).sending : (cfg.t || {}).submit;
  }

  function onSubmit(e) {
    e.preventDefault();
    if (busy || !cur) return;
    var t = cfg.t || {};
    var fd = new FormData(els.form);
    var m = method();
    var phone = str(fd.get('phone'), 40);
    var second = str(fd.get('contact'), 200);
    var name = str(fd.get('name'), 200);
    var comment = str(fd.get('comment'), 4000);
    var trap = str(fd.get('bt_hp_7'), 200);

    if (els.err) els.err.hidden = true;
    if (!m) { fail(t.err_method); return; }
    if (!name) { fail(t.err_required); return; }
    if (phone.replace(/\D/g, '').length < 9) { fail(t.err_phone); return; }
    if (second.length < 3) { fail(t.err_second); return; }
    if (m.kind === 'mail' && !EMAIL_RE.test(second)) { fail(t.err_email); return; }
    if (!/[^\d\s()+\-.]/.test(second) && second.replace(/\D/g, '').slice(-9) === phone.replace(/\D/g, '').slice(-9)) { fail(t.err_same); return; }
    var secondMail = EMAIL_RE.test(second);
    var value = (phone + ' · ' + second).slice(0, 300);

    var o = cur;
    var clientId = uuid();
    var source = ('popup:' + o.page + ':' + o.key).slice(0, 120);
    var rows = [];
    if (o.btnText) rows.push([t.row_button || 'Кнопка', o.btnText]);
    rows.push([t.row_key || 'Мітка', o.page + ' · ' + o.key]);
    for (var k in o.tagsObj) if (own(o.tagsObj, k)) rows.push([k, o.tagsObj[k]]);

    var lead = {
      kind: o.kind,
      client_id: clientId,
      source: source,
      name: name,
      contact_method: m.label,
      contact: value,
      message: comment,
      details: { channel: m.ch, estimate: rows }
    };
    lead.phone = phone;
    if (secondMail) lead.email = second;
    else if (/t\.me\//i.test(second) || (m.ch === 'telegram' && /^@?[A-Za-z][A-Za-z0-9_]{3,31}$/.test(second))) lead.telegram = second;
    var tg = tagsString(o.tagsObj);
    if (tg) lead.details.tags = tg;
    if (cfg.product && cfg.product.title) lead.details.product = { title: cfg.product.title, url: cfg.product.url || '' };
    if (o.meta_lead) lead.meta_lead = o.meta_lead;

    var lines = [
      '📋 ' + (o.b2b ? 'Корпоратив (поп-ап)' : 'Заявка з поп-апа'),
      'Сторінка: ' + (document.title || ''),
      String(location.href || '').split('#')[0],
      'Кнопка: ' + (o.btnText || o.key) + ' [' + source + ']',
      '',
      'Імʼя: ' + name,
      'Зручніше: ' + m.label,
      'Телефон: ' + phone,
      'Ще контакт: ' + second
    ];
    if (m.kind === 'phone' && m.ch === 'phone') lines.splice(6, 0, '📞 Просить подзвонити');
    if (comment) lines.push('Коментар: ' + comment);
    if (tg) lines.push('Мітки: ' + tg);
    try { if (window.btAttribution && window.btAttribution.lines) lines = lines.concat(window.btAttribution.lines()); } catch (err) {}

    /* Пастка заповнена — заявка лягає в склад «Спамом» (beacon, без Telegram і без
       запасного шляху), людині — той самий успіх, подій немає. */
    if (trap) {
      try {
        if (window.btLead && typeof window.btLead.beacon === 'function') {
          lead.details.honeypot = trap;
          window.btLead.beacon(lead);
        }
      } catch (err) {}
      done(null, m, o, false);
      return;
    }

    setBusy(true);
    var finished = false;
    function finish(res) {
      if (finished) return;
      finished = true;
      setBusy(false);
      if (res && res.ok) done(res, m, o, true, clientId);
      else fail(t.err_failed, true);
    }

    var btLead = window.btLead && typeof window.btLead.send === 'function' ? window.btLead : null;
    if (btLead) {
      var p = null;
      try { p = btLead.send(lead, { fallbackText: lines.join('\n') }); } catch (err) { p = null; }
      if (p && typeof p.then === 'function') { p.then(finish, function () { finish(null); }); return; }
    }
    /* bt-lead.js не завантажився — старий шлях, як у брифі. */
    try {
      fetch(cfg.notify || NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: lines.join('\n'), source: 'lead-popup' }),
        keepalive: true
      }).then(function (r) { finish({ ok: r.ok, via: 'telegram' }); }, function () { finish(null); });
    } catch (err) { finish(null); }
  }

  function done(res, m, o, real, clientId) {
    var t = cfg.t || {};
    var no = res && res.no ? String(res.no) : '';
    if (els.okTitle) els.okTitle.textContent = t.ok_title || '';
    if (els.okText) els.okText.textContent = fmt(t.ok_text, { method: m ? m.label : '' });
    if (els.okNo) { els.okNo.textContent = no ? fmt(t.ok_no, { no: no }) : ''; els.okNo.hidden = !no; }
    if (els.fields) els.fields.hidden = true;
    if (els.ok) els.ok.hidden = false;
    try { if (els.form) els.form.reset(); syncMethod(); } catch (e) {}
    try { if (els.okClose) els.okClose.focus(); } catch (e) {}
    if (real) track(o, clientId, m, res);
  }

  /* ── події ────────────────────────────────────────────────────────────── */

  function baseParams(o) {
    var a = attribution();
    var src = a.last || a.first || {};
    var p = {
      lead_kind: o.kind,
      lead_form: 'popup',
      lead_page: o.page,
      lead_button: o.key,
      lead_button_text: o.btnText,
      lead_via: o.via,
      page_path: location.pathname,
      lead_source: src.utm_source || src.ref || (src.direct ? 'direct' : ''),
      lead_medium: src.utm_medium || '',
      lead_campaign: src.utm_campaign || ''
    };
    for (var k in o.tagsObj) if (own(o.tagsObj, k)) p[k] = o.tagsObj[k];
    return p;
  }

  function dl(obj) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(obj); } catch (e) {}
  }

  function trackOpen(o) {
    var p = baseParams(o);
    var d = { event: 'lead_popup_open' };
    extend(d, p);
    dl(d);
    try { if (typeof window.clarity === 'function') { window.clarity('event', 'lead_popup_open'); window.clarity('set', 'lead_button', o.key); } } catch (e) {}
  }

  function ensureFbq() {
    if (typeof window.fbq === 'function') return window.fbq;
    var id = cfg.pixel;
    if (!id || !marketingOk()) return null;
    /* Базовий код Meta — як у bt-socd-designer.js: без PageView (його шле канал) */
    !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    if (!window.__socdFbqInit) {
      window.__socdFbqInit = true;
      window.fbq('set', 'autoConfig', false, id);
      window.fbq('init', id);
    }
    return window.fbq;
  }

  function sendMeta(o, id) {
    var ev = str(o.meta);
    if (!ev || ev === 'off' || !marketingOk()) return;
    var fq = ensureFbq();
    if (!fq) return;
    var data = { content_name: o.meta_name || o.page, content_category: o.meta_category || 'site_lead', lead_page: o.page, lead_button: o.key };
    if (o.valueNum) { data.value = o.valueNum; data.currency = cfg.currency; }
    var name = ev.replace(/^custom:/i, '');
    try {
      if (META_STD[name]) fq('track', name, data, { eventID: 'lead_' + id });
      else fq('trackCustom', name.replace(/[^A-Za-z0-9_]/g, '').slice(0, 40) || 'LeadPopup', data, { eventID: 'lead_' + id });
    } catch (e) {}
  }

  var gtagIds = {};
  var gtagOwn = false;
  function ensureGtag(id) {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
      gtagOwn = true;
      /* Наш gtag — лише за згоди (перевірено вище); стан згоди — як у Shopify. */
      window.gtag('consent', 'default', {
        ad_storage: marketingOk() ? 'granted' : 'denied',
        ad_user_data: marketingOk() ? 'granted' : 'denied',
        ad_personalization: marketingOk() ? 'granted' : 'denied',
        analytics_storage: analyticsOk() ? 'granted' : 'denied'
      });
      window.gtag('js', new Date());
    }
    if (!gtagIds[id]) {
      gtagIds[id] = true;
      var configured = false;
      try { configured = !!(window.google_tag_manager && window.google_tag_manager[id]); } catch (e) {}
      if (!configured) window.gtag('config', id, { send_page_view: false });
      if (gtagOwn && !document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
        document.head.appendChild(s);
      }
    }
    return window.gtag;
  }

  /* gtag бере gclid із cookie _gcl_aw; на PL наш gtag на сторінці входу не стояв —
     відновлюємо cookie з дотику (так само, як bt-design-request.js). */
  function restoreGclid() {
    if (cookie('_gcl_aw')) return;
    var a = attribution();
    var list = [a.last, a.first];
    for (var i = 0; i < list.length; i++) {
      var tt = list[i];
      if (!tt || typeof tt.gclid !== 'string' || tt.gclid.length < 9) continue;
      var left = Math.floor((Number(tt.ts) + 90 * 24 * 3600 * 1000 - Date.now()) / 1000);
      if (!(left > 0)) return;
      var host = location.hostname.replace(/^www\./, '');
      try {
        document.cookie = '_gcl_aw=GCL.' + Math.floor(Number(tt.ts) / 1000) + '.' + encodeURIComponent(tt.gclid) +
          '; max-age=' + left + '; path=/; domain=.' + host + '; SameSite=Lax; Secure';
      } catch (e) {}
      return;
    }
  }

  function sendGads(o, id) {
    var lab = str(o.gads);
    if (!lab || lab === 'off' || !marketingOk()) return;
    var sendTo = /^AW-\d+\/\S+$/.test(lab) ? lab : (cfg.gads_id ? cfg.gads_id + '/' + lab : '');
    if (!sendTo) return;
    try {
      restoreGclid();
      var g = ensureGtag(sendTo.split('/')[0]);
      var data = { send_to: sendTo, transaction_id: 'lead_' + id };
      if (o.valueNum) { data.value = o.valueNum; data.currency = cfg.currency; }
      g('event', 'conversion', data);
    } catch (e) {}
  }

  function sendGa4(o, params) {
    var name = str(o.ga4);
    if (!name || name === 'off' || !cfg.ga4_id || !analyticsOk()) return;
    try {
      var g = ensureGtag(cfg.ga4_id);
      var data = { send_to: cfg.ga4_id };
      extend(data, params);
      g('event', name.replace(/[^a-z0-9_]/gi, '').slice(0, 40) || 'generate_lead', data);
    } catch (e) {}
  }

  function track(o, id, m, res) {
    var p = baseParams(o);
    p.lead_method = m ? m.ch : '';
    p.lead_id = id;
    if (res && res.no) p.lead_no = String(res.no);
    var d = { event: str(o.ga4) && o.ga4 !== 'off' ? o.ga4 : 'generate_lead' };
    extend(d, p);
    dl(d);
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'lead_popup_sent');
        window.clarity('set', 'lead_source', p.lead_source || 'direct');
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('bt_lead_popup', p);
      }
    } catch (e) {}
    sendMeta(o, id);
    sendGa4(o, p);
    sendGads(o, id);
  }

  /* ── старт ────────────────────────────────────────────────────────────── */

  function init() {
    root = document.querySelector('[data-bt-leadpop]');
    if (!root) return;
    var c = root.querySelector('script[data-bt-leadpop-cfg]');
    if (!c) { root = null; return; }
    try { cfg = JSON.parse(c.textContent); } catch (e) { cfg = null; }
    if (!cfg || typeof cfg !== 'object') { root = null; cfg = null; return; }
    cfg._rules = parseRules(cfg.rules);
    var q = function (s) { return root.querySelector(s); };
    els = {
      dialog: q('[data-bt-leadpop-dialog]'), title: q('[data-bt-leadpop-title]'), sub: q('[data-bt-leadpop-sub]'),
      form: q('form'), fields: q('[data-bt-leadpop-fields]'), contact: q('input[name="contact"]'),
      contactLabel: q('[data-bt-leadpop-contact-label]'), contactHint: q('[data-bt-leadpop-contact-hint]'), comment: q('textarea[name="comment"]'),
      submit: q('[data-bt-leadpop-submit]'), err: q('[data-bt-leadpop-err]'), alt: q('[data-bt-leadpop-alt]'),
      ok: q('[data-bt-leadpop-ok]'), okTitle: q('[data-bt-leadpop-ok-title]'), okText: q('[data-bt-leadpop-ok-text]'),
      okNo: q('[data-bt-leadpop-ok-no]'), okClose: q('[data-bt-leadpop-ok-close]')
    };
    /* Поп-ап — прямий нащадок body: інакше transform / overflow батьківської секції
       ламають position: fixed. */
    try { if (root.parentNode !== document.body) document.body.appendChild(root); } catch (e) {}

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-bt-leadpop-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc') { close(); return; }
      if (e.key === 'Tab' && els.dialog) {
        var f = els.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([tabindex="-1"]), textarea, [tabindex="0"]');
        var vis = [];
        for (var i = 0; i < f.length; i++) if (f[i].offsetParent !== null) vis.push(f[i]);
        if (!vis.length) return;
        if (e.shiftKey && document.activeElement === vis[0]) { e.preventDefault(); vis[vis.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === vis[vis.length - 1]) { e.preventDefault(); vis[0].focus(); }
      }
    });
    if (els.form) {
      els.form.addEventListener('submit', onSubmit);
      els.form.addEventListener('change', function (e) { if (e.target && e.target.name === 'bt_lp_method') syncMethod(); });
      syncMethod();
    }
    /* Клік по месенджеру в блоці «Або напишіть нам» — сигнал, як у плаваючій кнопці. */
    if (els.alt) {
      els.alt.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[data-ch]') : null;
        if (a) dl({ event: 'contact_click', channel: a.getAttribute('data-ch'), placement: 'lead-popup' });
      });
    }
    /* Захоплення на window — раніше за обробник старого попапа на document. */
    window.addEventListener('click', onClick, true);

    /* ?lead-popup=1 у адресі — відкрити одразу (посилання з реклами чи розсилки). */
    try {
      var qs = new URLSearchParams(location.search);
      var auto = qs.get('lead-popup') || qs.get('lead_popup');
      if (auto) setTimeout(function () { open(null, 'url', { key: 'url-' + auto }); }, 400);
    } catch (e) {}
  }

  window.btLeadPopup = {
    v: 1,
    open: function (el, overrides) { if (cfg) open(el || null, 'api', overrides); },
    close: function () { close(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
